/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SharedSkill2 = {
  /**
   * The latest SKILL.md content.
   */
  content: string;
  /**
   * The user-facing skill name.
   */
  displayName: string;
  /**
   * The normalized skill name.
   */
  name: string;
  /**
   * The optional skill summary.
   */
  summary?: string | undefined;
  /**
   * When the shared content was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const SharedSkill2$inboundSchema: z.ZodMiniType<SharedSkill2, unknown> =
  z.pipe(
    z.object({
      content: z.string(),
      display_name: z.string(),
      name: z.string(),
      summary: z.optional(z.string()),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "display_name": "displayName",
        "updated_at": "updatedAt",
      });
    }),
  );

export function sharedSkill2FromJSON(
  jsonString: string,
): SafeParseResult<SharedSkill2, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SharedSkill2$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SharedSkill2' from JSON`,
  );
}
